<template>
  <wo-region>
    <form autocomplete="off">
      <po-input-field v-model="searchText" v-focus="action" :label="label" placeholder-key="general.searchTextPlaceholder" />
      <div v-wo-align:right>
        <po-promise-button label-key="general.action.search" @click="search" type="submit" mod-block />
      </div>
    </form>
  </wo-region>
</template>
<script>

import _ from 'lodash'

import { recoTypeSearchRepository } from '@/repository/reco'

export default {
  props: {
    action: Object,
    country: String
  },
  data () {
    return {
      searchText: undefined
    }
  },
  computed: {
    label () {
      return this.action && this.$t(this.action.inputKey, { country: 'NL' })
    },
    validFilter () {
      return _.size(this.searchText) > 2
    },
    filter () {
      return {
        [this.action.prop]: this.searchText,
        country: this.country
      }
    }
  },
  watch: {
    action () {
      this.searchText = undefined
    }
  },
  methods: {
    doFilter () {
      if (this.validFilter) {
        return this.$store.dispatch(recoTypeSearchRepository.findAll, { filter: this.filter, replace: true })
          .then(result => this.$emit('input', result))
      } else {
        this.$emit('input')
      }
    },
    search ({ detail }) {
      Promise.resolve(this.doFilter())
        .finally(detail.resolve)
    }
  }
}
</script>
